// extracted by mini-css-extract-plugin
module.exports = {"row":"CountRow__row--wX","wrapper":"CountRow__wrapper--Ni","changed":"CountRow__changed--St"};